import * as React from 'react';
import { VditorMarkdown } from './vditor-markdown';
import './style.scss';

interface IProps {
  readonly value: string;
  readonly className?: string;
  readonly placeholder?: string;
  readonly onVditorElementHeight?: (height: number) => void;
  readonly isPreview?: boolean;
}

interface IState {
  readonly value: string;
}

export const compatibleTGitTaskListValue = (str: string) =>
  str.replace(/(?:- \[)+.*/g, (matchValue: string) =>
    matchValue.replace(/\. /, '、')
  );

// markdown预览
export class MarkdownPreview extends React.Component<IProps, IState> {
  private divContainer: HTMLElement | null = null;
  public constructor(props: IProps) {
    super(props);
    this.state = {
      value: compatibleTGitTaskListValue(props.value),
    };
  }

  public componentWillReceiveProps(nextProps: IProps) {
    if (nextProps.value !== this.props.value) {
      this.renderMarked(nextProps.value);
    }
  }

  public componentWillMount() {
    this.renderMarked(this.props.value);
  }

  public componentDidMount() {
    this.bindEvent();
  }

  public componentDidUpdate(prevProps: Readonly<IProps>) {
    if (prevProps.value !== this.props.value) {
      this.renderMarked(this.props.value);
    }
  }

  public componentWillUnmount() {
    this.removeEvent();
  }

  public render() {
    return (
      <div
        className={`markdown-preview ${this.props.className || ''}`}
        ref={this.divContainerRef}
      >
        <VditorMarkdown
          isPreview={true}
          value={this.state.value}
          renderPreviewDone={this.renderPreviewDone}
        />
      </div>
    );
  }

  private removeEvent = () => {
    if (this.divContainer) {
      this.divContainer.removeEventListener('click', this.onHandleClick, false);
    }
  };

  private bindEvent = () => {
    if (this.divContainer) {
      this.divContainer.addEventListener('click', this.onHandleClick, false);
    }
  };

  private onHandleClick = (e: MouseEvent) => {
    if (e.target === null || !(e.target instanceof HTMLElement)) {
      return;
    }

    if (e.target.tagName === 'A') {
      e.preventDefault();
      const url = e.target.getAttribute('href');
      if (url) {
        window.open(url);
      }
      return;
    }
  };

  private divContainerRef = (el: HTMLElement | null) => {
    this.divContainer = el;
  };

  private renderMarked = async (value: string) => {
    if (this.divContainer) {
      let html: string = this.props.placeholder || ' ';
      if (value) {
        const newValue = compatibleTGitTaskListValue(value);
        html = newValue;
      }
      await this.setState({
        value: html,
      });
    }
  };

  // 编辑器渲染完成，相当于DOMContentLoaded 事件，图片、视频资源未加载完成
  // 此时获取的dom高度并不是真正的高度
  private renderPreviewDone = (height: number) => {
    if (this.props.onVditorElementHeight) {
      this.props.onVditorElementHeight(height);
    }
  };
}
